import React, { useMemo } from "react";
import { QueryRequestProvider, useQueryRequest } from "./core/QueryRequestProvider";
import {
  QueryResponseProvider,
  useQueryResponse,
  useQueryResponseData,
  useQueryResponseLoading,
  useQueryResponsePagination,
} from "./core/QueryResponseProvider";
import { DataTable } from "src/modules/Report/OA_List/Component/data-table";
import { columns } from "src/modules/Report/OA_List/Component/columns";
import { Button } from "src/shadcn/components/ui";
import { RefreshCcw } from "lucide-react";

const Main = ({ children }: { children: React.ReactNode }) => {
  const apiResp: any = useQueryResponseData();
  const isLoading = useQueryResponseLoading();

  const { refetch } = useQueryResponse();
  const tableData = useMemo(
    () =>
      Array.isArray(apiResp) && apiResp.length > 0
        ? apiResp?.map((d: any, indx: number) => {
            return {
              srNo: indx + 1,
              ...d,
            };
          })
        : [],
    [apiResp, isLoading]
  );
  return (
    <div className="w-full ">
      <div className=" space-x-2 flex items-center">
        {children}
        <Button onClick={() => refetch()} className="mt-6">
          <RefreshCcw />
        </Button>
      </div>
      <div className="mt-4">
        <DataTable
          columns={columns}
          data={tableData || []}
          isLoading={isLoading}
          useQueryRequest={useQueryRequest}
          useQueryResponseLoading={useQueryResponseLoading}
          useQueryResponsePagination={useQueryResponsePagination}
        />
      </div>
    </div>
  );
};

const OaListMain = (props: { children: React.ReactNode }) => {
  return (
    <QueryRequestProvider>
      <QueryResponseProvider>
        <Main {...props} />
      </QueryResponseProvider>
    </QueryRequestProvider>
  );
};

export default OaListMain;
